<template>
    <App :isShow="true">
        <div class="row px-0">
            <div class="v-col-sm-12 px-3 col-md-8 v-col-lg-9 text-center">
                <SubMenu @onSearch="onSearchHandle" :searchShow="true"/>
                <v-row>
                    <NewsCardTile
                        v-bind:key="post.id"
                        v-if="slug==='news' || slug==='photos' || slug==='others'"
                        v-for="post in articles"
                        :id="post.id"
                        :title="post.title"
                        :first_name="post.first_name"
                        :last_name="post.last_name"
                        :image="post.image"
                        :category_name="post.category_name"
                        :category_slug="post.category_slug"
                        :created_at="post.created_at"
                        :short_description="post.meta_description"
                        :body="post.body"
                    />

                    <PdfCardTile
                        v-bind:key="post.id"
                        v-if="slug==='books' || slug==='documents'"
                        v-for="post in articles"
                        :id="post.id"
                        :title="post.title"
                        :first_name="post.first_name"
                        :last_name="post.last_name"
                        :image="post.image"
                        :category_name="post.category_name"
                        :category_slug="post.category_slug"
                        :created_at="post.created_at"
                        :body="post.body"
                    />
                    
                    <AudioCardTile
                        v-bind:key="post.id"
                        v-if="slug==='audios'"
                        v-for="post in articles"
                        :id="post.id"
                        :title="post.title"
                        :first_name="post.first_name"
                        :last_name="post.last_name"
                        :image="post.image"
                        :category_name="post.category_name"
                        :category_slug="post.category_slug"
                        :created_at="post.created_at"
                        :format="post.format"
                        :link_url="post.link_url"
                    />

                    <VideoCardTile
                        v-bind:key="post.id"
                        v-if="slug==='videos'"
                        v-for="post in articles"
                        :id="post.id"
                        :title="post.title"
                        :first_name="post.first_name"
                        :last_name="post.last_name"
                        :image="post.image"
                        :category_name="post.category_name"
                        :category_slug="post.category_slug"
                        :created_at="post.created_at"
                        :body="post.body"
                        :format="post.format"
                        :link_url="post.link_url"
                    />
                </v-row>


                <div v-if="articles.length >= currentPage*12" class="fs-5 mt-3" @click="loadMore" role="button">
                    <span class=" text-grey-darken-1" v-if="isLoading">មើលបន្ថែមទៀត...</span>
                    <span class=" text-grey-darken-1" v-else>មើលបន្ថែមទៀត<i class="fa-solid fa-chevron-right fs-6"></i></span>
                </div>

                <div v-if="articles.length===0" class="text-center h-100">
                    <p class="text-grey ff-koulen fs-18 mt-5">មិនមានអត្ថបទ!</p>
                </div>
            </div>
            <div class="v-col-sm-12 col-md-4 v-col-lg-3">
                <RightSideBar />
            </div>
        </div>
        
    </App>
 

</template>

<script setup>

import App from "../Layouts/App";
import NewsCardTile from "../Components/NewsCardTile.vue";
import RightSideBar from "../Components/RightSideBar.vue";
import Search from "./Search.vue";
import {onMounted, reactive, ref} from "vue";
import axios from "axios";
import SubMenu from "../Components/Share/SubMenu.vue";
import PdfCardTile from "../Components/PdfCardTile.vue";
import AudioCardTile from "../Components/AudioCardTile.vue";
import VideoCardTile from "../Components/VideoCardTile.vue";
import {Inertia} from "@inertiajs/inertia";
import FloatingAudioPlayer from "../Components/FloatingAudioPlayer.vue";
import { library } from "webpack";


const props = defineProps({
    category: Object,
    posts: Array,
    slug: String,
    search: String,
});

const isLoading = ref(false);
const articles = ref(props.posts);
const currentPage = ref(1);
const search = ref('');


async function onSearchHandle(newSearch) {
    search.value = newSearch;
     Inertia.visit('/search/news', {
        method: 'get',
        data: {
            search: newSearch,
        },
        preserveState: true,
        replace: true,
        only: ['countPosts','search','posts','slug'],
    });
}


async function loadMore() {
    isLoading.value = true;
    const response = await axios.get(route('category.loadmore'), {
        params: {
            slug: props.category.slug,
            page: currentPage.value + 1,
            search: search,
        },
    });
    isLoading.value = false
    const data = response.data.data;
    if (data?.length>0) {
        articles.value.push(...data);
    }
    currentPage.value++;
}



onMounted(() => {
    // console.log({data: props.category})
});

</script>
